import script from "./SurveyMapFragenblockButtons.vue?vue&type=script&setup=true&lang=ts"
export * from "./SurveyMapFragenblockButtons.vue?vue&type=script&setup=true&lang=ts"

import "./SurveyMapFragenblockButtons.vue?vue&type=style&index=0&id=348f1726&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-348f1726"]])

export default __exports__